export function isAutoEncoder(obj) {
    return /* obj instanceof AutoEncoder || */ (typeof obj === 'object' && obj !== null && obj._isAutoEncoder);
}
//# sourceMappingURL=isAutoEncoder.js.map